/* 87C custom — cf snippets/_87c-customs-index.liquid */
/**
 * 87C Infinite Scroll — replaces pagination with scroll-triggered loading.
 *
 * Uses IntersectionObserver to detect when the user scrolls near the end
 * of the product grid. Fetches the next page via fetch(), extracts new
 * product cards, and appends them to the grid.
 *
 * Also re-initializes scroll-reveal animations on newly added cards.
 */
(function () {
	'use strict';

	var GRID_SELECTOR = '.c87-listing-grid';
	var PAGINATION_SELECTOR = '.c87-listing-pagination';
	var NEXT_LINK_SELECTOR = '.c87-listing-pagination a[rel="next"], .c87-listing-pagination .next a';
	var LOAD_MARGIN = '0px 0px 600px 0px'; /* trigger 600px before reaching end */

	var grid = document.querySelector(GRID_SELECTOR);
	var pagination = document.querySelector(PAGINATION_SELECTOR);
	if (!grid) return;

	/* Hide pagination immediately */
	if (pagination) {
		pagination.style.display = 'none';
	}

	var nextUrl = getNextUrl();
	var loading = false;
	var sentinel = null;

	function getNextUrl() {
		var link = document.querySelector(NEXT_LINK_SELECTOR);
		if (!link) {
			/* Try Shopify default pagination pattern */
			var allLinks = document.querySelectorAll('.c87-listing-pagination a');
			for (var i = 0; i < allLinks.length; i++) {
				if (allLinks[i].getAttribute('href') && allLinks[i].getAttribute('href').indexOf('page=') !== -1) {
					var currentPage = parseInt(allLinks[i].textContent);
					if (!isNaN(currentPage)) {
						/* Find the highest page number link */
					}
				}
				/* Check for › or next arrow */
				if (allLinks[i].classList.contains('next') || allLinks[i].textContent.trim() === '›') {
					return allLinks[i].getAttribute('href');
				}
			}
		}
		return link ? link.getAttribute('href') : null;
	}

	function createSentinel() {
		if (sentinel) sentinel.remove();
		sentinel = document.createElement('div');
		sentinel.className = 'c87-infinite-sentinel';
		sentinel.setAttribute('aria-hidden', 'true');
		grid.parentElement.insertBefore(sentinel, grid.nextSibling);
		return sentinel;
	}

	function createLoader() {
		var loader = document.createElement('div');
		loader.className = 'c87-infinite-loader';
		loader.innerHTML = '<span></span>';
		loader.setAttribute('aria-label', 'Chargement…');
		grid.parentElement.insertBefore(loader, grid.nextSibling);
		return loader;
	}

	function loadNextPage() {
		if (loading || !nextUrl) return;
		loading = true;

		var loader = createLoader();

		fetch(nextUrl, { credentials: 'same-origin' })
			.then(function (response) { return response.text(); })
			.then(function (html) {
				var parser = new DOMParser();
				var doc = parser.parseFromString(html, 'text/html');

				/* Extract new product cards from the fetched page */
				var newGrid = doc.querySelector(GRID_SELECTOR);
				if (newGrid) {
					var newCards = newGrid.children;
					var fragment = document.createDocumentFragment();

					while (newCards.length > 0) {
						var card = newCards[0];
						/* Apply scroll-reveal to new cards */
						card.classList.add('c87-reveal');
						fragment.appendChild(card);
					}

					grid.appendChild(fragment);

					/* Trigger scroll-reveal on new cards after a frame */
					requestAnimationFrame(function () {
						var unrevealed = grid.querySelectorAll('.c87-reveal:not([data-revealed])');
						unrevealed.forEach(function (el) {
							el.setAttribute('data-revealed', '');
						});
					});
				}

				/* Find next page URL from fetched page */
				var newPagination = doc.querySelector(PAGINATION_SELECTOR);
				if (newPagination) {
					var newNext = newPagination.querySelector('a[rel="next"], .next a');
					if (!newNext) {
						/* Try arrow pattern */
						var links = newPagination.querySelectorAll('a');
						for (var i = 0; i < links.length; i++) {
							if (links[i].classList.contains('next') || links[i].textContent.trim() === '›') {
								newNext = links[i];
								break;
							}
						}
					}
					nextUrl = newNext ? newNext.getAttribute('href') : null;
				} else {
					nextUrl = null;
				}

				loader.remove();
				loading = false;

				/* Re-observe if there are more pages */
				if (nextUrl) {
					observeSentinel();
				} else if (sentinel) {
					sentinel.remove();
				}
			})
			.catch(function () {
				loader.remove();
				loading = false;
				/* On error, show pagination as fallback */
				if (pagination) pagination.style.display = '';
			});
	}

	function observeSentinel() {
		var el = createSentinel();

		var observer = new IntersectionObserver(function (entries) {
			if (entries[0].isIntersecting) {
				observer.disconnect();
				loadNextPage();
			}
		}, { rootMargin: LOAD_MARGIN });

		observer.observe(el);
	}

	/* Start observing if there's a next page */
	if (nextUrl) {
		observeSentinel();
	}
})();
